import { useSearchParams } from 'react-router-dom'

// Same wiring as useSendTaskParam: the dialog is mounted once in Layout and
// opened by a URL param, so any entry point (dashboard quick action, the
// Talent Coaching page) is ordinary navigation to ?coach=1 instead of
// needing to reach a shared component. `coach=<userId>` opens it straight
// on that person (the Coaching page's "Log a conversation with Jalen").
export function useCoachParam() {
  const [params, setParams] = useSearchParams()

  const raw = params.get('coach')
  const open = raw != null && raw !== ''
  const personId = open && raw !== '1' ? raw : null

  const close = () => {
    const next = new URLSearchParams(params)
    next.delete('coach')
    setParams(next, { replace: true })
  }

  return { open, personId, close }
}
